import KidScreener from './KidScreener';

export default KidScreener;
